import React from 'react';
import Tabs, { TabsProps } from '@material-ui/core/Tabs';
import AppBar, { AppBarProps } from '@material-ui/core/AppBar';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import Container from '@material-ui/core/Container';
import '../AppTheme/index';
import { EdwardColors } from 'enums';

interface MarginProps {
  noMargin: boolean;
  noPadding: boolean;
  overflow: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: (props: MarginProps) => ({
      zIndex: 1,
      background: theme.palette.background.paper,
      boxShadow: 'none',
      color: '#818284',
      borderRadius: `${theme.borderRadius.box} ${theme.borderRadius.box} 0 0`,
      marginBottom: props.noMargin ? theme.spacing(1) : theme.spacing(4),
      '& .Mui-selected': { color: EdwardColors.SECONDARY },
      '& .MuiTab-textColorInherit': { opacity: 1 },
      '& > .MuiContainer-root': props.noPadding ? { padding: 0 } : undefined,
      '& .MuiTabs-root': props.overflow
        ? {
            overflow: 'visible !important',
            '& div.MuiTabs-scroller': {
              overflow: 'visible!important',
            },
          }
        : undefined,
      '& .MuiTab-wrapper': { lineHeight: '18px', fontWeight: 700 },
      '& .MuiTabs-indicator': {
        height: '4px',
      },
    }),
  }),
);

interface OwnProps {
  appBarProps?: AppBarProps;
  noMargin?: boolean;
  noPadding?: boolean;
  fullWidth?: boolean;
  overflow?: boolean;
}

export type Props = OwnProps & TabsProps;

const CustomTabs: React.FC<Props> = ({ children, appBarProps, noMargin, noPadding, fullWidth, overflow, ...props }) => {
  const { appBar } = useStyles({ noMargin: !!noMargin, noPadding: !!noPadding, overflow: !!overflow });

  return fullWidth ? (
    <AppBar position="static" className={appBar} {...appBarProps}>
      <Tabs {...props} variant="fullWidth">
        {children}
      </Tabs>
    </AppBar>
  ) : (
    <Container maxWidth="md">
      <AppBar position="static" className={appBar} {...appBarProps}>
        <Tabs {...props} variant="fullWidth">
          {children}
        </Tabs>
      </AppBar>
    </Container>
  );
};

export default CustomTabs;
